"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OneMediaParagraphTextLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _shared = require("../shared");
var _constants = require("../shared/TextBox/constants");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OneMediaParagraphTextLayout = (param)=>{
    let { banner, debug, modulePosition, className } = param;
    var _modules_;
    const { getTestId } = (0, _testidGenerator.default)();
    const { layout, modules, id } = banner;
    const isMobile = (0, _presentationHooks.useIsMobile)();
    if (!modules || modules.length < 1) {
        return (0, _utils.getModulesLengthError)({
            debug,
            layout,
            modulePosition
        });
    }
    var _modules_1;
    // Can't use TextBox as the link is in another module
    const { link } = (_modules_1 = modules[0]) !== null && _modules_1 !== void 0 ? _modules_1 : {};
    var _modules__content;
    const { textCollection, title } = (_modules__content = (_modules_ = modules[1]) === null || _modules_ === void 0 ? void 0 : _modules_.content) !== null && _modules__content !== void 0 ? _modules__content : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.OneMediaRoot, {
        "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.OneMediaParagraphText),
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ImageBox, {
                id: id,
                module: modules[0],
                imageParams: _constants2.IMAGE_PARAMS.params,
                sizes: _constants2.IMAGE_PARAMS.sizes,
                height: _constants2.IMAGE_DESKTOP_HEIGHT,
                width: _constants2.IMAGE_DESKTOP_WIDTH
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.TextWrapper, {
                children: [
                    title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Title, {
                        title: title,
                        maxLines: isMobile ? 5 : 4,
                        titleVariant: isMobile ? 'h5' : 'h4'
                    }) : null,
                    textCollection && textCollection.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                        children: textCollection.map((text, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.TextWithHtml, {
                                html: (0, _utils.transformHtmlContent)(text),
                                elementsProps: _constants.elementsProps
                            }, (0, _utils.getKey)('text', index)))
                    }) : null,
                    link ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Button, {
                        link: link
                    }) : null
                ]
            })
        ]
    });
};
exports.OneMediaParagraphTextLayout = OneMediaParagraphTextLayout;
